export default __webpack_public_path__ + "static/media/introduce.84f63342.png";